(function () {
  var original = theme.buildProductImage;
  if (!original) return;

  var placeholderUrlEl = document.getElementById('poolaroo-placeholder-url');
  var placeholderSrc = placeholderUrlEl ? placeholderUrlEl.getAttribute('data-url') : '';
  if (!placeholderSrc) return;

  theme.buildProductImage = function (product, imageSizes) {
    if (product && product.featured_image) {
      return original.call(this, product, imageSizes);
    }

    var size = (theme.settings && theme.settings.productImageSize) || 'natural';
    var alt = (product && product.title) ? String(product.title).replace(/"/g, '&quot;') : 'Product placeholder';
    var imgHtml = '<img src="' + placeholderSrc + '" alt="' + alt + '" class="poolaroo-placeholder-svg" loading="lazy">';

    if (size === 'natural') {
      return '<div class="image-wrap product-image--placeholder-wrap">' + imgHtml + '</div>';
    }
    return '<div class="grid__image-ratio grid__image-ratio--' + size + ' product-image--placeholder-wrap">' + imgHtml + '</div>';
  };
})();
